// Fetch wrapper with credentials: include — cookies (HttpOnly) carry the JWT.
// All paths are relative; Vite proxies /api → :3000 in dev, same-origin in prod.

async function request(method, path, body) {
  const res = await fetch(path, {
    method,
    credentials: 'include',
    headers: body ? { 'Content-Type': 'application/json' } : undefined,
    body: body ? JSON.stringify(body) : undefined,
  });
  const isJson = res.headers.get('content-type')?.includes('application/json');
  const data = isJson ? await res.json() : null;
  if (!res.ok) {
    const err = new Error(data?.error || `HTTP ${res.status}`);
    err.status = res.status;
    err.code = data?.code;
    throw err;
  }
  return data;
}

export const api = {
  get: (path) => request('GET', path),
  post: (path, body) => request('POST', path, body),
  put: (path, body) => request('PUT', path, body),
  patch: (path, body) => request('PATCH', path, body),
  del: (path, body) => request('DELETE', path, body),
  upload: async (path, formData) => {
    const res = await fetch(path, { method: 'POST', credentials: 'include', body: formData });
    const isJson = res.headers.get('content-type')?.includes('application/json');
    const data = isJson ? await res.json() : null;
    if (!res.ok) {
      const err = new Error(data?.error || `HTTP ${res.status}`);
      err.status = res.status;
      err.code = data?.code;
      throw err;
    }
    return data;
  },
};

export const PO_STATUSES = ['DRAFT', 'ORDERED', 'RECEIVED', 'CANCELLED'];
export const APPROVAL_STATUSES = ['AUTO_APPROVED', 'PENDING', 'APPROVED', 'REJECTED'];
export const CURRENCIES = ['CAD', 'USD'];
export const PAYMENT_METHODS = ['IT_CARD', 'CONCESSION_DIRECT', 'OTHER'];
export const SUBSCRIPTION_CYCLES = ['MONTHLY', 'YEARLY'];
